import { render, staticRenderFns } from "./_search.vue?vue&type=template&id=4a2678d2"
import script from "./_search.vue?vue&type=script&lang=ts"
export * from "./_search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports